/**
 * The function `handleKeyPress` prevents the space key from being processed.
 * @param event - The event parameter represents the keyboard event that occurred. It contains
 * information about the key that was pressed, such as the key code and key value.
 */
export const handleKeyPress = (event) => {
  if (event.key === " ") {
    event.preventDefault(); // Evita que se procese la tecla de espacio
  }
};
